module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h84tJ"))).then(() => parcelRequire('9Lwss'));